import styled from "styled-components";

const AccountLayoutHolder = styled.div`
  width: 100%;
  padding: 140px 24px 40px;

  @media only screen and (max-width: 768px) {
    padding: 90px 12px 24px;
  }

  .accountLayout__inner {
    display: flex;
    gap: 24px;
    align-items: flex-start;
    max-width: 1240px;
    margin: auto;
  }

  .accountLayout__content {
    flex: 1;
    min-width: 0;
  }

  @media only screen and (max-width: 768px) {
    .accountLayout__inner {
      flex-direction: column;
    }
  }
`;

export default AccountLayoutHolder;
